
export { legacyApiAuth } from "/builds/dd3tech/wiggot/wiggot-web/packages/apis/legacies-api/legacy-api.ts"
export { monopolioApi } from "/builds/dd3tech/wiggot/wiggot-web/packages/apis/legacies-api/legacy-api.ts"
export { wiggotAPI } from "/builds/dd3tech/wiggot/wiggot-web/packages/apis/legacies-api/wiggot-api.ts"